<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
          <el-button
          size="mini"
          type="primary"
          @click="create"
          icon="el-icon-plus"
          >添加</el-button
        >
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{row}">
            <el-button type="text" @click="details(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/mall/balance/list";
import editDialog from "@/components/mall/balance/editDialog";

export default {
  name: "balance",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  methods: {
    details(row) {
      let data = row;
      this.$refs.editDialog.openDetails(data);
    },
  },
};
</script>